import React from 'react'
import CryptoNews from './child/CryptoNews'


const DashBoardLayerThree = () => {

  return (
    <section className="row gy-4">
      {/* RevenueReportOne */}
      <CryptoNews />

      

    </section>


  )
}

export default DashBoardLayerThree